import { render, staticRenderFns } from "./RelevantPlaceItem.vue?vue&type=template&id=4bac9808&"
import script from "./RelevantPlaceItem.vue?vue&type=script&lang=js&"
export * from "./RelevantPlaceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports